export type CurrencyCode = "AUD" | "USD" | "EUR" | "GBP" | "CAD" | "SGD" | "INR";

export const CURRENCY_OPTIONS: Array<{ code: CurrencyCode; label: string }> = [
  { code: "AUD", label: "AUD (Australia)" },
  { code: "USD", label: "USD (United States)" },
  { code: "EUR", label: "EUR (Europe)" },
  { code: "GBP", label: "GBP (United Kingdom)" },
  { code: "CAD", label: "CAD (Canada)" },
  { code: "SGD", label: "SGD (Singapore)" },
  { code: "INR", label: "INR (India)" },
];

export const DEFAULT_RATES_FROM_AUD: Record<CurrencyCode, number> = {
  AUD: 1,
  USD: 0.66,
  EUR: 0.61,
  GBP: 0.52,
  CAD: 0.9,
  SGD: 0.89,
  INR: 55,
};

const CURRENCY_LOCALES: Record<CurrencyCode, string> = {
  AUD: "en-AU",
  USD: "en-US",
  EUR: "en-IE",
  GBP: "en-GB",
  CAD: "en-CA",
  SGD: "en-SG",
  INR: "en-IN",
};

const EURO_COUNTRIES = new Set([
  "AT",
  "BE",
  "CY",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PT",
  "SK",
  "SI",
  "ES",
]);

const COUNTRY_TO_CURRENCY: Record<string, CurrencyCode> = {
  AU: "AUD",
  US: "USD",
  CA: "CAD",
  GB: "GBP",
  SG: "SGD",
  IN: "INR",
};

export const detectCurrency = (): CurrencyCode => {
  if (typeof navigator === "undefined") return "AUD";
  const locale = navigator.language || "";
  const region = locale.split("-")[1]?.toUpperCase() || "";
  if (EURO_COUNTRIES.has(region)) return "EUR";
  return COUNTRY_TO_CURRENCY[region] || "AUD";
};

export const convertAudTo = (amountAud: number, currency: CurrencyCode, rates?: Record<CurrencyCode, number>) =>
  amountAud * ((rates && rates[currency]) || DEFAULT_RATES_FROM_AUD[currency] || 1);

export const formatMoney = (amount: number, currency: CurrencyCode) =>
  new Intl.NumberFormat(CURRENCY_LOCALES[currency] || "en", {
    style: "currency",
    currency,
    maximumFractionDigits: 2,
  }).format(amount);

export const formatFromAud = (amountAud: number, currency: CurrencyCode, rates?: Record<CurrencyCode, number>) =>
  formatMoney(convertAudTo(amountAud, currency, rates), currency);
